import { useHistory } from 'react-router-dom';
import { Button } from 'ypf-pas-general-ui-components';

import img from '../../assets/img-error404.svg';
import './NotFound.scss';

const NotFound = () => {
  const history = useHistory();
  return (
    <div className="container">
      <img src={img} alt="error" />
      <h1 className="error-title">¡Ups!</h1>
      <h2 className="error-subtitle">
        La página a la que intentas ingresar no existe.
      </h2>
      <Button
        type="button"
        label="Volver"
        variant="primary"
        onClick={() => history.goBack()}
      />
    </div>
  );
};

export default NotFound;
